import { render, staticRenderFns } from "./MyAboutsRP.vue?vue&type=template&id=580ef7e5"
import script from "./MyAboutsRP.vue?vue&type=script&lang=js"
export * from "./MyAboutsRP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports